// extracted by mini-css-extract-plugin
export default {"p_tye":"_9e1f866493","slcted":"_650412a327","slc_color":"_70cc600518","item_p":"_2bf69ab605","r0":"c882a5f269"};